// extracted by mini-css-extract-plugin
module.exports = {"carousel":"photo_slider_carousel__1diqS","carouselItem":"photo_slider_carouselItem__37iIb","boxArrows":"photo_slider_boxArrows__1LWKC"};